export default "__VITE_ASSET__CF0B9Fp5__"